export default "__VITE_ASSET__CMfx$buy__"